import { IAddressProps } from "interfaces/Address";
import { IBankingDataProps } from "interfaces/BankingData";
import { IContactProps } from "interfaces/Contact";
import {
  IFilteredPolicemen,
  IPoliceman,
  IPolicemanProps,
  IPolicemanServiceProps,
  IPolicemanUpdateServiceProps,
  IUpdatePolicemen,
} from "interfaces/Policeman";
import { IUserToPolicemanProps } from "interfaces/User";
import { IVehicleProps } from "interfaces/Vehicle";
import {
  activePolicemen,
  createPolicemanService,
  deletePolicemen,
  getUpdatePolicemenService,
  updatePolicemanService,
} from "../PolicemenServices";

export async function handlePolicemanRegisterSubmit({
  policeman,
  contact,
  vehicle,
  address,
  banking,
  user,
  provider,
  pictures,
}: IPolicemanServiceProps) {
  return await createPolicemanService({
    policeman,
    contact,
    vehicle,
    address,
    banking,
    user,
    provider,
    pictures,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function handlePolicemanUpdateSubmit({
  policeman,
  contact,
  user,
  baking,
  address,
  vehicle,
  pictures,
}: IPolicemanUpdateServiceProps) {
  return await updatePolicemanService({
    policeman,
    contact,
    baking,
    address,
    user,
    vehicle,
    pictures,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function handlePolicemanActiveSubmit({
  policeman,
}: IDeletePolicemanRegisterProps) {
  if (policeman) {
    activePolicemen(policeman.id)
      .then((res) => {
        localStorage.setItem("message", "Policial ativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no policeman is selected");
  }
}

export function handlePolicemanDeleteSubmit({
  policeman,
}: IDeletePolicemanRegisterProps) {
  if (policeman) {
    deletePolicemen(policeman.id)
      .then((res) => {
        localStorage.setItem("message", "Policial desativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no policeman is selected");
  }
}

export function filteredHandle(
  policemen: IPoliceman[],
  updatePoliceman: IUpdatePolicemen[]
): IFilteredPolicemen {
  const working: IPoliceman[] = [];
  const toApprove: IPoliceman[] = [];
  const modified: IUpdatePolicemen[] = updatePoliceman;

  policemen.forEach((policeman) => {
    if (policeman.working) working.push(policeman);
    if (!policeman.approved) toApprove.push(policeman);
  });

  return {
    all: policemen,
    working,
    toApprove,
    modified,
  };
}

export function handleSetPoliceman({
  setUser,
  user,
  setPoliceman,
  policeman,
  setContact,
  contact,
}: ISetPolicemanRegisterProps) {
  setPoliceman(policeman);
  setContact(contact);
  setUser(user);
}

export function handleSetBanking({
  setBanking,
  banking,
}: ISetBankingRegisterProps) {
  setBanking(banking);
}

export function handleSetAddress({
  setAddress,
  address,
}: ISetAddressRegisterProps) {
  setAddress(address);
}

export function handleSetVehicle({
  setVehicle,
  vehicle,
}: ISetVehicleRegisterProps) {
  setVehicle(vehicle);
}
interface ISetVehicleRegisterProps {
  setVehicle: (value: IVehicleProps) => void;
  vehicle: IVehicleProps;
}
interface ISetAddressRegisterProps {
  setAddress: (value: IAddressProps) => void;
  address: IAddressProps;
}
interface ISetBankingRegisterProps {
  setBanking: (value: IBankingDataProps) => void;
  banking: IBankingDataProps;
}
interface ISetPolicemanRegisterProps {
  setPoliceman: (value: IPolicemanProps) => void;
  setUser: (value: IUserToPolicemanProps) => void;
  setContact: (value: IContactProps) => void;
  policeman: IPolicemanProps;
  user: IUserToPolicemanProps;
  contact: IContactProps;
}
interface IDeletePolicemanRegisterProps {
  policeman?: IPoliceman;
}
